module.exports = __webpack_public_path__ + "static/media/lens_rb.6caa7f57.png";